<script>
import MultiStepForm from '@phoenix/mixins/components/form/MultiStepForm';
import FormNavigation from '@maison/components/form/FormNavigation';
import formBasicMixin from '@phoenix/mixins/formBasicMixin';
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    FormNavigation,
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
  },

  mixins: [formBasicMixin, MultiStepForm],

  props: {
    onSuccessCallback: {
      type: Function,
      default: () => ({}),
    },
  },
};
</script>

<template>
  <div>
    <form-navigation
      v-if="hasSteps"
      ref="formNavigation"
      :form-name="form.name"
      :steps="steps.length"
      :current-step="currentStep"
      @change-step="changeStep"
    />

    <section class="section">
      <phoenix-form
        v-model="fields"
        :prefill-enabled="form.prefillEnabled"
        :redirect-url="redirectUrl"
        :terms-link="termsLink"
        :terms="terms"
        :captcha-enabled="form.captchaEnabled"
        :action="form.action"
        :form-type="form.name"
        :custom-submit-text="form.submitLabel"
        :on-success-callback="onSuccessCallback"
        :steps="steps.length"
        :current-step="currentStep"
        :should-save-in-local-storage="form.shouldSaveInLocalStorage"
        :should-reset-form-on-submit="form.shouldResetFormOnSubmit"
        @change-step="changeStep"
      >
        <fieldset v-for="step in steps" :key="`step-${step.step}`">
          <component
            :is="step.component"
            v-if="currentStep === step.step"
            v-bind="step.attrs"
            v-model="fields"
            :step="step.step"
            :data-cy="`step-${step.step}`"
            @change-step="changeStep"
          />
        </fieldset>
      </phoenix-form>
    </section>
  </div>
</template>
